import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

// ---------------------- Variables

const enableStore = import.meta.env.VITE_CURRENT_MODE !== "production";

// ---------------------- Interfaces

interface RouteState {
  // --------- State

  currentRoute: string | null;
  previousRoute: string | null;

  // --------- Actions

  setCurrentRoute: (path: string) => void;
  setPreviousRoute: (path: string | null) => void;
}

// ---------------------- Store

export const useRouteStore = create<RouteState>()(
  devtools(
    immer((set) => ({
      // --------- State

      currentRoute: null,
      previousRoute: null,

      // --------- Actions

      setCurrentRoute: (path: string) =>
        set(
          (state) => {
            state.currentRoute = path;
          },
          false,
          "route/setCurrentRoute",
        ),

      setPreviousRoute: (path: string | null) =>
        set(
          (state) => {
            state.previousRoute = path;
          },
          false,
          "route/setPreviousRoute",
        ),
    })),
    {
      name: "RouteStore",
      enabled: enableStore,
      store: "RouteStore",
    },
  ),
);
